var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8247 3.63202C32.3679 1.21067 29.6972 0 26.7837 0H12.2163C9.30276 0 6.63206 1.21067 5.17531 3.63202C-0.408891 12.1067 -1.62285 24.9399 2.26181 27.6034C6.14648 30.2668 14.887 18.6444 19.5 18.6444C24.113 18.6444 32.6107 30.2668 36.7382 27.6034C40.6228 24.9399 39.4089 12.1067 33.8247 3.63202ZM14.6442 12.1067H12.2163V14.5281H9.78835V12.1067H7.36043V9.68539H9.78835V7.26404H12.2163V9.68539H14.6442V12.1067ZM27.7549 13.3174C27.7549 14.5281 26.7837 15.4966 25.5698 15.4966C24.3558 15.4966 23.3847 14.5281 23.3847 13.3174C23.3847 12.1067 24.3558 11.1382 25.5698 11.1382C26.7837 11.1382 27.7549 12.1067 27.7549 13.3174ZM32.3679 8.47471C32.3679 9.68539 31.3968 10.6539 30.1828 10.6539C28.9689 10.6539 27.9977 9.68539 27.9977 8.47471C27.9977 7.26404 28.9689 6.2955 30.1828 6.2955C31.3968 6.2955 32.3679 7.26404 32.3679 8.47471Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.5fb91f0f24c33f781c54ed8fdea10135.svg";
export { ForwardRef as ReactComponent };